import type { Action } from 'flow/store/engine/types';
import { ActionType } from 'flow/store/engine/constants';
import {
  beginWorkflowHistoryTransaction,
  createActionsThunk,
} from 'flow/store/redux/thunks';
import {
  findNextActionPrecedence,
  PREVIEW_WORKFLOW_ROUTING_ACTION_NAME,
} from 'flow/service/actions';
import { generatePublicId } from 'flow/service/publicIds';

import type { useAppDispatch } from '~/store/reduxHooks';


export function handleOnAddWorkflowRoutingClick(
  dispatch: ReturnType<typeof useAppDispatch>,
  workflowRoutingActions: Action[],
  isWorkflowHistoryOn: boolean,
) {
  if (isWorkflowHistoryOn && !dispatch(beginWorkflowHistoryTransaction())) return null;

  const publicId = generatePublicId('action', ActionType.WORKFLOW);
  const name = PREVIEW_WORKFLOW_ROUTING_ACTION_NAME;
  const precedenceIndex = findNextActionPrecedence(workflowRoutingActions);

  dispatch(createActionsThunk({
    type: ActionType.WORKFLOW,
    args: {
      publicId,
      name,
      precedenceIndex,
      workflowId: null,
    },
  }));

  return publicId;
}
